import { alias } from '@ember/object/computed';

import Model, { belongsTo, hasMany } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  primaryTarget: [validator('belongs-to'), validator('presence', true)],
});

export default class NewsletterModel extends Model.extend(Validations) {
  @belongsTo('newsletter-target', { async: true, inverse: null }) primaryTarget;
  @hasMany('newsletter-target', { async: true, inverse: null })
  additionalTargets;

  // Getter, setter and computed properties
  @alias('primaryTarget.name') displayHeadline;
  @alias('primaryTarget.name') displayLabel;
}
